export const CATEGORY_PRODUCT = [
  {
    title: "ВСЁ",
    // type:'all',
  },

  {
    title: "⛺ПАЛАТКИ",
    type: "tent",
  },
  {
    title: "🎒РЮКЗАКИ",
    type: "backpack",
  },
  {
    title: "🥾ОБУВЬ",
    type: "shoes",
  },
  {
    title: "💤СПАЛЬНЫЕ МЕШКИ",
    type: "sleepingbag",
  },
  {
    title: "📏КОВРИКИ·КАРЕМАТЫ",
    type: "mat",
  },
  {
    title: "🦯ТРЕКИНГОВЫЕ ПАЛКИ",
    type: "trekkingsticks",
  },
  {
    title: "🧥ДОЖДЕВИКИ·ГЕРМОМЕШКИ",
    type: "hermo",
  },
  {
    title: "🔥ГАЗ·ГОРЕЛКИ",
    type: "gas/burner",
  },
  {
    title: "🧣БАФФЫ · БАЛАКЛАВЫ · ПЕРЧАТКИ",
    type: "buff",
  },
  {
    title: "🧢ГОЛОВНЫЕ УБОРЫ",
    type: "hat",
  },

  {
    title: "🔭БИНОКЛЬ",
    type: "binoculars",
  },
  // {
  //   title: "🧤ПЕРЧАТКИ",
  //   type: "gloves",
  // },
  {
    title: "🧦НОСКИ",
    type: "socks",
  },
  {
    title: "🔦ФОНАРИ",
    type: "lantern",
  },

  {
    title: "🕶️ОЧКИ И АКСЕССУАРЫ",
    type: "sunglasses",
  },
  {
    title: "🥤ТЕРМОС·ТЕРМОРЮКЗАК",
    type: "termoryukzak",
  },
  {
    title: "💧БУТЫЛКИ",
    type: "bottle",
  },
  {
    title: "🍽️ПОСУДА",
    type: "dishes",
  },
  {
    title: "🔪НОЖИ И ИНСТРУМЕНТ",
    type: "knife",
  },
  {
    title: "🪑КЕМПИНГОВАЯ МЕБЕЛЬ",
    type: "chair",
  },

  {
    title: "🛌НАДУВНАЯ ПРОДУКЦИЯ",
    type: "air",
  },
  {
    title: "🦟СПРЕИ И ОТПУГИВАТЕЛИ",
    type: "spray",
  },

  {
    title: "ИНОЕ",
    type: "accessories",
  },
  {
    title: "🧼УХОД ЗА ОБУВЬЮ И ОДЕЖДОЙ",
    type: "care",
  },
  // {
  //   title: "🍲ПОХОДНАЯ ЕДА",
  //   type: "sublimates",
  // },
  // {
  //   title: "☕КОФЕ",
  //   type: "coffee",
  // },
  {
    title: "🎿МАСКА/ШЛЕМ ГОРНОЛЫЖНЫЕ",
    type: "skigoggles",
  },
  {
    title: "ТЕРМОБЕЛЬЕ/ЗАЩИТА",
    type: "thermalUnderwear",
  },
];
